import httpServer from "../axios";
import {baseUrlx,baseUrlq} from "..";

export default {
  // 省
  getProvince(params) {
    return httpServer('get',baseUrlq + "api/common/area/xixun/province/list", params,false);
  },
  getCity(cityId) {
    return httpServer('get',`${baseUrlq}api/common/area/xixun/city/list/${cityId}`,{},false);
  },
  getStudentApply(params){
    return httpServer('post',baseUrlx + "api/school/sxh/apply/list", params);
  },
  // 申请试用
  applyTry(params) {
    return httpServer('post',baseUrlx + "operator/apply", params);
  },
  getCode(params){
    return httpServer('get',baseUrlx + "companyuser/code", params);

  },
  getFoodBed(){
    return httpServer('get',baseUrlq+ "api/sys/list/food_bed",{},false);
  },
  getJobList(){
    return httpServer('get',baseUrlq+ "api/common/job_type/list",{},false);
  }
};